import { localState0 } from "./localState0";

export const tempTesting = false;
export const useLocal = false;
export const autoSignIn = true;

/*

Dev:
    SUPERADMIN
        04065662
        ahmed_fayyaz@outlook.com
        devpass

        94562455
        kabir@bcs.com
        devpass

    DEVSTORE
        00002450
        supp1@bcs.com
        devpass

        0002451
        supp2@bcs.com
        devpass


    WORKER
        98761234

Prod:
    SUPERADMIN
        04065662
        ahmed_fayyaz@outlook.com
        p123456

        94562455
        kabir@bcs.com
        p123456

    DEVSTORE
        00002450
        supp1@bcs.com
        p123456

        0002451
        supp2@bcs.com
        p123456


    WORKER
        98761234

*/

let targetTest = localState0.devWorker;
export const localState = targetTest;



// WEBPACK FOOTER //
// ./src/staticData/rawState.js